import { useEffect, useMemo, useState } from 'react'
import { debounce } from 'debounce'

interface IState {
    isMobile: boolean
    isTablet: boolean
    isDesktop: boolean
}

const useResponsive = (): IState => {
    // screen resolutions
    const [state, setState] = useState({
        isMobile: false,
        isTablet: false,
        isDesktop: false,
    })

    useEffect(() => {
        // update the state on the initial load
        debouncedResizeHandler()

        // assign the event
        Setup()

        return () => {
            // remove the event
            Cleanup()
        }
    }, [])

    // update the state on window resize
    const onResizeHandlerMemoized = useMemo(
        () => (): void => {
            const isMobile = window.innerWidth <= 575
            const isTablet = window.innerWidth > 575 && window.innerWidth <= 768
            const isDesktop = window.innerWidth > 768

            setState({ isMobile, isTablet, isDesktop })
        },
        []
    )

    // debounced resizeHandler
    const debouncedResizeHandler = debounce(onResizeHandlerMemoized, 50)

    // add event listener
    const Setup = (): void => {
        window.addEventListener('resize', debouncedResizeHandler, false)
    }

    // remove the listener
    const Cleanup = (): void => {
        window.removeEventListener('resize', debouncedResizeHandler, false)
    }

    return state
}

export default useResponsive
